import { render, staticRenderFns } from "./syncStaffDatas.vue?vue&type=template&id=1c530f52&scoped=true&"
import script from "./syncStaffDatas.vue?vue&type=script&lang=js&"
export * from "./syncStaffDatas.vue?vue&type=script&lang=js&"
import style0 from "./syncStaffDatas.vue?vue&type=style&index=0&id=1c530f52&lang=less&scoped=true&"
import style1 from "./syncStaffDatas.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c530f52",
  null
  
)

component.options.__file = "syncStaffDatas.vue"
export default component.exports